export default "__VITE_ASSET__0e88078c__"